import React from 'react'
import { translateNode } from 'src/localization/translateNode'

export const valueIsEmpty =
  (message?: string) =>
  (val?: unknown): React.ReactElement | undefined =>
    val === undefined
      ? translateNode(message !== undefined ? message : 'Must not be blank')
      : undefined
